import * as Types from '@wandb/weave/core';

export const inputType = Types.ALL_DIR_TYPE;
